import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/standardStorageHardLimitModalQuery.graphql';
import type {
	ModalProps,
	StandardStorageHardLimitQueries,
} from './standard-storage-hard-limit-modal';

export type EntryPointParams = {
	/** The cloud id of the site the dialog is shown on */
	cloudId: string;
	/** The HAMS key of the product the dialog is shown for, for example `jira-software` */
	hamsProductKey: string;
};

type StandardStorageHardLimitEntryPointComponent = EntryPointComponent<
	StandardStorageHardLimitQueries,
	Record<string, never>,
	ModalProps,
	Record<string, never>
>;

const standardStorageHardLimitEntryPoint: EntryPoint<
	StandardStorageHardLimitEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<StandardStorageHardLimitEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-storage-hard-limit-modal" */ './standard-storage-hard-limit-modal',
		{
			moduleId: 'edition-awareness-standard-storage-hard-limit-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			standardStorageHardLimitModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});

export default standardStorageHardLimitEntryPoint;
